import { getName } from '../../../../../../shared/helpers/Model';

export default ({ record }) => {
  const { uploadOwner } = record.populated;
  return uploadOwner ? getName(uploadOwner.params) : 'Upload Job';
};
